import React, { useCallback, useEffect, useState, Children } from "react";
import { Alert, Form, Modal, Spinner } from "react-bootstrap";
import { InputText } from "../../../../../components/Inputs";
import { useForm } from "../../../../../hooks/useForm";
import { useValidator } from "../../../../../hooks/useValidator";
import { useLang } from "../../../../../language";

import { Calendar, momentLocalizer } from 'react-big-calendar'

import moment from 'moment'
import { ButtonSpinner } from "../../../../../components/ButtonSpinner/ButtonSpinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { isStatusSucess } from "../../../../../helpers/helpers";
import { AlquileresServices } from "./services/alquileres.service";
import { InputSelect } from "../../../../../components/Inputs/InputSelect";
import { cloneDeep } from "lodash";
import { AparatosServices } from "../Aparatos/controllers/services/aparatos.service";

const localizer = momentLocalizer(moment)
require('moment/locale/ca.js')

export const ModalAlquileres = ({ showModal_Alquileres, handleCloseModal_Alquileres }: any) => {

    const Lang = useLang()

    const [events, setEvents] = useState<any>([])

    const [startEndDates, setStartEndDates] = useState<any>({});

    const [objFechasData, setObjFechasData] = useState<any>({});

    const [startEndSlot, setStartEndSlot] = useState<any>({
        start: '',
        end: '',
    });

    const lang = {
        ca: {
            week: 'Setmana',
            work_week: 'Setmana de treball',
            day: 'Dia',
            month: 'Mes',
            previous: '<',
            next: '>',
            today: 'Avui',
            agenda: 'El Diari',

            showMore: (total: any) => `+${total} més`,
        }
    }


    const [formDatosGenerales, handleInputDatosGenerales, handleFormDatosGenerales, resetDatosGenerales] = useForm({
        // ...InformacionAdicionalAdapters.GET.receive.schema({}),
        title: Lang('EVENTO'),
        idaparato: '',
    })

    const getStartAndEndDate = (date: Date) => {

        const firstDay = moment(new Date(date.getFullYear(), date.getMonth(), 1)).format('YYYY-MM-DD');
        const lastDay = moment(new Date(date.getFullYear(), date.getMonth() + 1, 0)).format('YYYY-MM-DD');

        setStartEndDates({
            fechainicio: firstDay,
            fechafin: lastDay,
        })
    };

    const onNavigate = useCallback((date: Date) => {
        getStartAndEndDate(date);
    }, []);


    const [fetchCheckDisponibilidad, fetchCheckDisponibilidadData] = AlquileresServices.GET_CHECK_DISPONIBILIDAD()

    useEffect(() => {

        if (isStatusSucess(fetchCheckDisponibilidadData.status)) {

            setObjFechasData(fetchCheckDisponibilidadData.data?.data)
        }

    }, [fetchCheckDisponibilidadData]);


    useEffect(() => {

        if (startEndDates.fechainicio && startEndDates.fechafin && formDatosGenerales.idaparato) {

            fetchCheckDisponibilidad({
                params: {
                    fechadesde: startEndDates.fechainicio,
                    fechahasta: startEndDates.fechafin,
                    idproducto: formDatosGenerales.idaparato,
                    estricto: false,
                }
            })
        }

    }, [startEndDates.fechainicio, startEndDates.fechafin, formDatosGenerales.idaparato]);


    const ColoredDateCellWrapper = useCallback(({ children, value }: any) => {

        let color = ''

        const diaActual = moment(new Date(value)).format('YYYY-MM-DD')

        // if (formDatosGenerales.horainicio === diaActual) {
        //     color = '#6bebb0'
        // }

        // -------- Colorear slot seleccionado

        const startEndSlotTemp = cloneDeep(startEndSlot)

        let slotStart = startEndSlotTemp.start
        let slotEnd = startEndSlotTemp.end

        if (!slotEnd) slotEnd = slotStart

        if ((new Date(value))?.getTime() >= (new Date(slotStart + 'T00:00:00'))?.getTime() &&
            (new Date(value))?.getTime() <= (new Date(slotEnd + 'T00:00:00'))?.getTime()) {
            color = '#b0efbf'
        }

        // -------- Colorear dia festivo

        if (isFeriadoySabadoODomingo(value, startEndDates, objFechasData)) {
            color = '#ffe6e6'
        }

        return React.cloneElement(Children.only(children), {
            style: {
                ...children.style,
                backgroundColor: color,
            },
        })

    }, [startEndDates, startEndSlot, objFechasData])


    const isFeriadoySabadoODomingo = (value: any, startEndDates: any, objFechasData: any) => {

        const valueDate = new Date(value)

        const valueDateFormat = moment(new Date(value)).format('YYYY-MM-DD')

        const fechainicio = new Date(startEndDates.fechainicio)
        const fechafin = new Date(startEndDates.fechafin)

        if (fechainicio?.getTime() <= valueDate.getTime() && valueDate.getTime() <= fechafin?.getTime()) {

            if (valueDate.getDay() === 6 || valueDate.getDay() === 0 || (objFechasData[valueDateFormat] && objFechasData[valueDateFormat] !== 'diadecobro')) {

                return true
            }
        }

        return false
    }

    useEffect(() => {

        getStartAndEndDate(new Date());

    }, [])


    const [valuesValidationEvento, handleValidationEvento, handleResetValidationEvento] = useValidator({
        horainicio: { isOk: true, msgError: [Lang('ALERT_OBLIGATORIO_GENERICO')] },
        horafin: { isOk: true, msgError: [Lang('ALERT_OBLIGATORIO_GENERICO')] },
    })

    const [fetchAparatosGET, fetchAparatosGETData] = AparatosServices.GET()

    useEffect(() => {

        if (showModal_Alquileres.value) {

            fetchAparatosGET({
                params: {
                    limit: 100,
                    status: 'activos'
                }
            })

        } else {

        }

    }, [showModal_Alquileres.value]);


    return (
        <>
            <Modal show={showModal_Alquileres.value} onHide={handleCloseModal_Alquileres} dialogClassName='modal-70vw' id='ModalRegistro'>
                <Modal.Header className='border-bottom-0 py-4'>
                    <Modal.Title className='h5'>{Lang('VER_CALENDARIO')}</Modal.Title>
                    <Form.Group className="col-lg-4">
                        <div className="d-flex align-items-center">
                            <span className="pe-3">{Lang('APARATO')}: </span>
                            <InputSelect
                                name='idaparato'
                                size="sm"
                                value={formDatosGenerales.idaparato}
                                values={fetchAparatosGETData.data?.items?.map((item: any) => {
                                    return {
                                        id: item.id,
                                        nombre: item.producto
                                    }
                                }) || []}
                                onChange={handleInputDatosGenerales}
                            />
                        </div>
                    </Form.Group>
                </Modal.Header>
                <Modal.Body className='px-4 py-0'>

                    <section className="position-relative">
                        <Calendar
                            localizer={localizer}
                            events={events}
                            startAccessor="start"
                            endAccessor="end"
                            style={{ height: 400 }}
                            // onSelectEvent={handleSelectEvent}
                            // onSelectSlot={handleSelectSlot}
                            culture='ca'
                            messages={lang['ca']}
                            views={
                                {
                                    month: true
                                }
                            }
                            selectable
                            components={{
                                dateCellWrapper: ColoredDateCellWrapper
                            }}
                            onNavigate={onNavigate}

                        />
                        {
                            fetchCheckDisponibilidadData.loading &&
                            <div className="d-flex py-5 justify-content-center align-items-center OverlayCalendar__Loading">
                                <Spinner animation="border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </Spinner>
                            </div>
                        }
                    </section>

                </Modal.Body>
                <Modal.Footer className='border-0 d-flex justify-content-between'>

                </Modal.Footer>
            </Modal>
        </>
    )
};
